// find the matching lockerId from the nameData
export const findLockerName = (lockerId, nameData) => {
  const locker = nameData.find(
    (locker) => parseInt(locker.lockerId) === parseInt(lockerId)
  );

  return locker ? locker.lockerName : null;
};
